import type { FunctionComponent } from "react";

import {
  Banner,
  Container,
  ContentContainer,
  Flexi,
  Opinion,
  SectionBlock,
  StyledBannerImage,
  StyledFlexiImage,
  StyledOpinionHeaderImage,
  StyledOpinionImage,
  StyledSectionBlockImage,
  StyledSectionBlockMobileImage,
  StyledSectionBlockSmallMobileImage,
  StyledTopNewsImage,
  StyledTopNewsMobileImage,
  StyledTopSmallNewsImage,
  TopNews,
  TopSmallNews,
  VerticalLine,
} from "./styles";

type Props = {
  className?: string;
};

export const HomeV2Placeholder: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <ContentContainer>
      <VerticalLine />
      <Banner>
        <StyledBannerImage />
      </Banner>
      <Flexi>
        <StyledFlexiImage />
      </Flexi>
      <Opinion>
        <StyledOpinionHeaderImage />
        <StyledOpinionImage />
      </Opinion>
      <TopNews>
        <StyledTopNewsImage />
        <StyledTopNewsMobileImage />
      </TopNews>
      <TopSmallNews>
        <StyledTopSmallNewsImage />
      </TopSmallNews>
      <SectionBlock>
        <StyledSectionBlockImage />
        <StyledSectionBlockImage />
        <StyledSectionBlockImage />
        <StyledSectionBlockSmallMobileImage />
        <StyledSectionBlockSmallMobileImage />
        <StyledSectionBlockMobileImage />
      </SectionBlock>
    </ContentContainer>
  </Container>
);

HomeV2Placeholder.displayName = "HomeV2Placeholder";
